import React from 'react';
import { Row, Col, Result } from 'antd';
import FunctionalityCard from '../components/Home/FunctionalityCard';
import GcPagina from '../components/Layout/GcPagina';
import { usePermissions } from '../contexts/PermissionContext';
import { useMenuItems } from '../components/Layout/menuItems';

/**
 * Descripción de cada entrada del menú en su tarjeta del inicio. Las tarjetas salen de la misma
 * definición que el raíl (menuItems, filtrada por ACL): una por entrada de primer nivel; las
 * secciones de segundo nivel abren un menú contextual con sus opciones (decisión de Javier,
 * 2026-10-04, spec rev. 2).
 */
const DESCRIPCIONES: Record<string, string> = {
  '/transmisiones': 'Gestión y seguimiento de transmisiones',
  'vinculacion-datos-oficiales': 'Conciliación, vinculación y mejora de CU2',
  '/brevo-sync': 'Sincronización de contactos con Brevo',
  'i-d': 'KardioChat y registro de actividad del agente comercial',
  clientes: 'Listado, altas y duplicados de clientes',
  '/oportunidades': 'Oportunidades de venta, de compra y solicitudes de información',
  '/seguimiento-fdoc': 'Estado de los documentos del FDoc enviados a firma',
  '/seguimiento-pactos': 'Envíos del Pacto de Firma por WhatsApp y su respuesta',
  '/encuestas-cx': 'Campaña semanal ROC, OC y SI, Mystery F4 y encuestas registradas',
  '/ferias': 'Fichas de feria: carga, bandeja y lectura',
  '/empleados': 'Fichas de empleados: alta, edición, roles y baja',
};

const HomePage: React.FC = () => {
  const { hasPermission, permissions } = usePermissions();
  const items = useMenuItems().filter((i) => i.key !== '/');

  // Sin ningún permiso útil
  if (!hasPermission('GCvsc.Menu.Read') && permissions.length === 0) {
    return (
      <Result
        status="403"
        title="Sin acceso"
        subTitle="Tu usuario no tiene permisos asignados en GCvsc. Contacta con Sistemas si crees que es un error."
      />
    );
  }

  // Modo completo con menú → panel de control con tarjetas filtradas por permisos
  return (
    <GcPagina titulo="Panel de Control" contexto="Módulos disponibles para tu usuario">
      <Row gutter={[16, 16]}>
        {items.map((it) => (
          <Col key={it.key} xs={24} sm={12} md={8} lg={6}>
            <FunctionalityCard
              title={it.label}
              icon={it.icon}
              description={DESCRIPCIONES[it.key]}
              path={it.children ? undefined : it.key}
              opciones={it.children?.map((h) => ({ key: h.key, label: h.label, icon: h.icon }))}
            />
          </Col>
        ))}
      </Row>
    </GcPagina>
  );
};

export default HomePage;
